import { EuiSpacer } from '@elastic/eui';
import ONVIFTable from 'components/Web_User_Interface/720p_Series/System/ONVIF/onvifTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  ONVIFTable,
  BreadCrumbs,
  SEOHelmet,
  React
};